import { useMutation } from '@apollo/client';
import { graphql } from 'gql.tada';

const CreateCourseMutation = graphql.persisted(
  "CreateCourse",
  graphql(`
    mutation CreateCourse($input: CreateCourseInput!) {
      createCourse(input: $input) {
        course {
          id
          name
          slug
          classOfferings {
            id
            section
            displayName
            term { id name startsOn endsOn }
          }
        }
        userErrors {
          message
          path
        }
      }
    }
  `)
);

export { CreateCourseMutation };

export function useCreateCourse() {
  return useMutation(CreateCourseMutation);
}
